import { createContext, useContext } from "react";

// When true, Autocomplete option menus render into a `document.body` portal
// (fixed position, z-index above the modal layer) so they escape the clipping
// `overflow-y: auto` scroll region of an enclosing record-prompt modal
// (`.recordPrompt__content`, capped at `max-height: 80vh`) instead of being
// clipped to a single visible row. The record-prompt dialogs (RecordPrompt /
// RecordPromptPopover) provide `true`; everywhere else the default `false`
// keeps the inline (non-portaled) menu that list-cell inline editing relies on
// for its portal-aware outside-click containment.
export const AutocompleteMenuPortalContext = createContext(false);

export const useAutocompleteMenuPortal = () => useContext(AutocompleteMenuPortalContext);
